export const FormValidators = Object.freeze({
    emailOrUsername: 'required|minLength=6|maxLength=100',
    password: 'required|minLength=6|maxLength=100',
    phone: 'number'
});